import React, { useEffect, useState } from "react";
import {
  Switch,
  Route,
} from "react-router-dom";

import publicRoute from '../routes/public/publicRoutes';
import privateRoute from '../routes/private/privateRoutes';
import firebaseApp from "../api/config";
import { useAppContext } from "../lib/context";
import Loading from "../lib/loading";
import { storageHelper } from "../lib";


const NotFound = () => {
  return <h1>Not Found</h1>;
};

export default function Routes() {
  const [, dispatch] = useAppContext();
  const [loading, setLoading] = useState(true);  

  useEffect(() => {
    firebaseApp.auth().onAuthStateChanged((authUser) => {

      if (authUser && authUser.refreshToken) {
        setLoading(false)
        dispatch({
          type: "user",
          user: authUser,
        });
        storageHelper.set("refreshToken", authUser.refreshToken)
      }
      if (!(authUser && authUser.refreshToken))
      {
        setLoading(false)
        storageHelper.remove("refreshToken");
      }

    })
  }, [dispatch]);

  return (
    <Switch>
      {loading && <Loading />}
      {publicRoute}
      {privateRoute}
      <Route path="*" component={NotFound} />
    </Switch>
  );
}